import * as React from "react";
import { Button } from "@shared/common";
import { translate } from "@klantondersteuning/shared";

export interface OpnieuwBeginnenButtonProps {
  buttonText?: string;
  onClick: () => void;
}

export const OpnieuwBeginnenButton: React.FunctionComponent<OpnieuwBeginnenButtonProps> = (props) => {
  const buttonText = props.buttonText ?? translate("TerugNaarHetFormulier");

  return <Button layout="primary" buttonText={buttonText} clickHandler={props.onClick}></Button>;
};
